import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      organization: null,
      isAuthenticated: false,
      
      setAuth: (user, token) => set({ 
        user, 
        token, 
        isAuthenticated: true 
      }),
      
      setOrganization: (organization) => set({ organization }),
      
      logout: () => set({ 
        user: null, 
        token: null, 
        organization: null, 
        isAuthenticated: false 
      }),
    }),
    {
      name: 'infrashield-auth',
    }
  )
);

export default useAuthStore;
